import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter, useHistory } from 'react-router-dom';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';
import UiKitButton from 'components/UiKit/Button';
import ErrorIcon from 'assets/error-circle-outline.svg?react';
import { company as companyApi } from 'utilities/api';
import catchCancel from 'helpers/catchCancel';
import { paths } from 'routes/paths';
import './index.css';

const DeleteCompanyModal = ({
  open,
  close,
  companyName = '',
  companyId = ''
}) => {
  const history = useHistory();
  const [isSaving, setIsSaving] = useState(false);
  const handleDelete = async () => {
    setIsSaving(true);
    const { promise } = companyApi.delete(companyId);
    await promise
      .then(() => {
        history.push({
          pathname: paths.companies,
          selectedView: 'comfortable'
        });
        window.location.reload(false);
      })
      .catch(catchCancel)
      .catch(() => {
        history.go({
          pathname: paths.companies,
          selectedView: 'comfortable'
        });
      });
  };

  const actionPerformed = 'Delete "';
  const closeQuote = '"';

  return (
    <Modal
      open={open}
      title={
        <div className="company-delete-modal-header">
          <ErrorIcon width={24} height={24} aria-hidden="true" />
          <h3>{actionPerformed + companyName + closeQuote}</h3>
        </div>
      }
      onCancel={close}
      closable={false}
      width={512}
      centered
      destroyOnClose
      transitionName="syt-antd-fade"
      footer={null}
      className="company-delete-modal"
    >
      <div className="company-delete-modal-content">
        You are about to permanently delete this Company. This cannot be undone.
        Are you sure you want to proceed?
      </div>
      <div className="company-delete-modal-actions">
        <UiKitButton variant="outline" onClick={close}>
          Cancel
        </UiKitButton>
        <UiKitButton
          variant="primary"
          danger
          onClick={handleDelete}
          disabled={isSaving}
          loading={isSaving}
        >
          Delete
        </UiKitButton>
      </div>
    </Modal>
  );
};

DeleteCompanyModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  companyName: PropTypes.string,
  companyId: PropTypes.string
};

export default withRouter(DeleteCompanyModal);
